import { FragmentType, graphql } from "@/gql"
import { getFragmentData } from "@/gql-clients/experimental/getFragmentData"
import { JobPostingStatus, MyJobsJobPostStatusDeterminatorFragmentDoc } from "@/gql/graphql"

graphql(`
  fragment MyJobsJobPostStatusDeterminator on JobPosting {
    id
    applicationCount
    shortlistedApplicationCount
    chatCount
    invitationCount
    status
  }
`)

export enum Action {
  SEND_INVITE = "Send invites",
  REVIEW_APPLICATIONS = "Review applicants",
  MESSAGE_APPLICANTS = "Message applicants",
  //HIRE = "Mark a hire",
  CLOSE_JOB = "Close job",
  CLOSED = "Closed",
}

export const determineJobPostingAction = (
  jobPostingFragment: FragmentType<typeof MyJobsJobPostStatusDeterminatorFragmentDoc> | null | undefined
) => {
  const jobPosting = getFragmentData(MyJobsJobPostStatusDeterminatorFragmentDoc, jobPostingFragment)
  const invites = jobPosting?.invitationCount || 0
  const applications = jobPosting?.applicationCount || 0
  const shortlistedApplications = jobPosting?.shortlistedApplicationCount || 0
  const chats = jobPosting?.chatCount || 0

  /* 
  bring back when hires are ready
  
  const hires = 0
  if (hires > 0) return Action.CLOSE_JOB
  if (chats > 0) return Action.HIRE 
  */

  if (jobPosting?.status === JobPostingStatus.Closed) return Action.CLOSED
  if (chats > 0) return Action.CLOSE_JOB
  if (shortlistedApplications > 0) return Action.MESSAGE_APPLICANTS
  if (applications > 0) return Action.REVIEW_APPLICATIONS
  if (invites === 0) return Action.SEND_INVITE

  return Action.SEND_INVITE
}

export const jobActionComparison = (action: Action, isAfter: Action): "past" | "present" | "future" => {
  return action === isAfter
    ? "present"
    : Object.values(Action).indexOf(action) > Object.values(Action).indexOf(isAfter)
      ? "past"
      : "future"
}

export const actionProgressPercentage = (action: Action) => {
  const index = Object.values(Action).indexOf(action)
  if (index === -1) {
    return "0"
  }
  const total = Object.keys(Action).length
  const percentage = `${((index + 1) / (total + 1)) * 100}%`
  return percentage
}
